/**
 * Thrown when the create didn't produce a check-in to navigate to.
 *
 * The store reports failed requests and returns `{ success: false }` rather than
 * throwing, so a rejected create used to resolve to `undefined` and the modal
 * simply sat there — indistinguishable from the button not working.
 */
export class CheckinCreateError extends Error {
  constructor(
    /** Server-authored text safe to show the user, when there is any. */
    public readonly userMessage?: string,
  ) {
    super('checkin-create-failed')
    this.name = 'CheckinCreateError'
  }
}

type ErrorEntry = { title?: string; detail?: string }

/**
 * Prefers the server's `detail` (the actual validation message, e.g. "Assessor
 * must be active and belong to the same organisation") over its `title`, so the
 * user is told what to change instead of "Something went wrong".
 */
export const userMessageFromErrors = (errors: unknown): string | undefined => {
  if (!Array.isArray(errors)) return undefined

  const messages = (errors as ErrorEntry[])
    .map((error) => error?.detail || error?.title)
    .filter((message): message is string => !!message)

  return messages.length > 0 ? messages.join(' ') : undefined
}
